var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#444;}.b,.c{fill:none;}.c{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8.5,
    cy: 8.5,
    r: 8.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.238 3.238)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 10.524,
    height: 10.524
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.631 2.631)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 5.262,
    y2: 5.262
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 5.262,
    y2: 5.262
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.8fcd02a31cb5fd60becf71a0e2980f02.svg";
export { ForwardRef as ReactComponent };